module.exports = __webpack_public_path__ + "img/323-circle-right.98d84002.svg";